import Component from '../abstracts/Component';
import Cookies from 'js-cookie';
import PopupManager from '../utils/PopupManager';
import NewsletterLogic from '../logics/NewsletterLogic';
import { IS_PRIVACY_PAGE } from '../utils/Environment';

export default class NewsletterPopupComponent extends Component {
  get SELECTORS() {
    return {
      doItLater: '[data-do-it-later]',
      input: '[data-newsletter-input]',
      formBox: '[data-newsletter-form-box]',
      closeBtn: '[data-close-popup]',
    };
  }

  get CLASSES() {
    return {
      success: 'success',
      componentExtended: 'extended',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.form = this.$component.querySelector(this.SELECTORS.form);
    this.doItLater = this.$component.querySelector(this.SELECTORS.doItLater);
    this.newsletterPopupTimer = document.body.dataset.newsletterPopupTimer;
    this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    // loading logics
    this.NewsletterLogic = new NewsletterLogic();
  }

  // istantiate properties
  initProperties() {
    this.modalkey = document.body.dataset.nlKey
      ? document.body.dataset.nlKey
      : 'default_modal';
    this.link = document.body.dataset.nlLink
      ? document.body.dataset.nlLink
      : '/modals/newsletter';
    this.hideCookieKey = 'nl_' + this.modalkey + '_hide';
  }

  listenEmailInput(component) {
    let mailInput = component.$component.querySelector(this.SELECTORS.input);
    if (mailInput != null) {
      mailInput.addEventListener('focus', () => {
        let formBox = component.$component.querySelector(
          this.SELECTORS.formBox
        );
        if (formBox != null) {
          formBox.classList.add(this.CLASSES.componentExtended);
        }
      });
    }
  }

  bindEvents() {
    let ctx = this;

    if (this.doItLater) {
      this.doItLater.addEventListener('click', () =>
        this.$emit(this.$customEvents.NL_POPUP_EVENTS.hide)
      );
    }

    let newsletterPopupTimer = parseInt(this.newsletterPopupTimer) ?? 0;

    // controllo presenza cookie, se in pagina privacy e se esiste la login popup
    let visibileLoginPopup = document.getElementById('loginPopup') !== null;

    if (
      !Cookies.get(this.hideCookieKey) &&
      !IS_PRIVACY_PAGE &&
      !visibileLoginPopup
    ) {
      // EMIT this event when needed to show newsletter popup after 5 sec
      setTimeout(() => {
        ctx.$emit(ctx.$customEvents.NL_POPUP_EVENTS.show, { component: ctx });
      }, newsletterPopupTimer); // TODO: add property to set timeout
    }

    this.$on(this.$customEvents.NL_POPUP_EVENTS.show, ({ payload }) => {
      ctx.listenEmailInput(payload.component);
    });

    // after subscription event
    this.$on(this.$customEvents.NL_POPUP_EVENTS.subscribed, () => {
      // set cookie
      this.setHideCookie();
    });

    // after open event
    this.$on(this.$customEvents.NL_POPUP_EVENTS.shown, () => {
      let closeBtn = this.closeBtn;
      if (closeBtn != null) {
        closeBtn.addEventListener('click', () => {
          this.setHideCookie();
        });
      }
    });
  }

  setHideCookie() {
    Cookies.set(this.hideCookieKey, 'true', {
      expires: 365,
      path: '/',
    });
  }

  render() {
    // properties
    this.initProperties();

    // popup manager
    this.popupManager = new PopupManager({
      eventGroup: 'NL_POPUP_EVENTS',
      component: this.$component,
    });

    // events
    this.bindEvents();
  }
}
